var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1 6.90286C1 4.19509 3.08448 2 5.65581 2H10.3442C12.9155 2 15 4.19508 15 6.90286C15 9.61063 12.9155 11.8057 10.3442 11.8057H8.6462L9.85472 13.1293C10.0417 13.334 10.0356 13.6596 9.84118 13.8564C9.64676 14.0533 9.33759 14.0469 9.15065 13.8422L7.14707 11.6479C6.97292 11.4572 6.96461 11.1584 7.12786 10.9573L9.13144 8.48871C9.30668 8.2728 9.61495 8.24737 9.81999 8.43191C10.025 8.61645 10.0492 8.94108 9.87393 9.157L8.55897 10.7771H10.3442C12.3761 10.7771 14.0233 9.04256 14.0233 6.90286C14.0233 4.76315 12.3761 3.02857 10.3442 3.02857H5.65581C3.62392 3.02857 1.97674 4.76315 1.97674 6.90286V7.07165C1.97674 9.11814 3.55216 10.7771 5.49553 10.7771C5.76525 10.7771 5.9839 11.0074 5.9839 11.2914C5.9839 11.5755 5.76525 11.8057 5.49553 11.8057C3.01272 11.8057 1 9.6862 1 7.07165V6.90286Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/Reset.ac619a47247057ac07fe487a573e39a5.svg";
export { ForwardRef as ReactComponent };